import { useCallback, useEffect } from "react";
import { useSearchParamState } from "@/common/hooks/nuqs/useSearchParamState.ts";
import { URLSearchParamKeys } from "@/enum/URLSearchParamKeys.ts";
import useExplorerBreadcrumbs from "@/common/hooks/useExplorerBreadcrumbs.ts";
import usePlaylists from "@/common/hooks/usePlaylists.ts";

function useLoadBreadcrumbsBySearchParam() {
  const [playlists] = usePlaylists();
  const [playlistId] = useSearchParamState(URLSearchParamKeys.PLAYLIST);
  const [, setExplorerBreadcrumbs] = useExplorerBreadcrumbs();

  const getBreadcrumbsFromPlaylists = useCallback((playlistId: string) => {
    const breadcrumbs = [];
    let currentItem = playlists[playlistId];

    while (currentItem) {
      breadcrumbs.push(currentItem);
      currentItem = playlists[currentItem.explorerItemParentId];
    }

    return breadcrumbs.reverse();
  }, [playlists]);

  useEffect(() => {
    if (!playlistId) {
      setExplorerBreadcrumbs([])
      return;
    }
    const breadcrumbs = getBreadcrumbsFromPlaylists(playlistId);
    setExplorerBreadcrumbs(breadcrumbs);
  }, [
    playlistId,
    getBreadcrumbsFromPlaylists,
    setExplorerBreadcrumbs
  ]);
}

export default useLoadBreadcrumbsBySearchParam;
